'use client';
import React from 'react';

const recognitions = [
  {
    title: 'SecureOps selected as a 2026 Cyber150 winner by IT-Harvest',
    description:
      'SecureOps has been named a 2026 Cyber 150 winner by IT-Harvest, recognizing its growth, innovation, and contribution to the future of cybersecurity through continuous security validation.',
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'read the full note',
  },
  {
    title: 'SecureOps recognized as a Challenger / Fast Mover in the GigaOm Radar for 2025',
    description:
      "We\'re proud to share that SecureOps has been recognized as a Challenger and Fast Mover in the Innovation/Feature quadrant of the latest GigaOm Radar.",
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'read the full note',
  },
  {
    title: 'SecureOps now on Gartner Peer Insights',
    description:
      'By joining Gartner Peer Insights, SecureOps is opening a new space for transparency, where clients can share how continuous security validation and AI-driven DevSecOps help them stay one step ahead.',
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'read the full note',
  },
  {
    title: 'SecureOps featured in Forbes: Leading the next chapter of cybersecurity innovation',
    description:
      "Forbes features SecureOps's founder on its cover, a story of bold leadership, innovation, and how SecureOps is redefining DevSecOps through AI and global growth.",
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'read the full note',
  },
];

export default function RecognitionSection() {
  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 mb-16">
          <div className="lg:w-1/2">
            <p className="font-mono-brand text-[0.7rem] text-[#80edfa] uppercase tracking-widest mb-4">
              Third-Party Proof
            </p>
            <h2 className="font-heading text-[clamp(2rem,4vw,3rem)] text-[#f5f5f8] font-medium leading-tight">
              Recognized by the industry.<br />
              Backed by results.
            </h2>
          </div>
          <div className="lg:w-1/2 flex items-end">
            <p className="text-[#aaa] text-base leading-relaxed">
              From independent evaluations and analyst reports to awards and client recognition, see how SecureOps is earning trust across the cybersecurity ecosystem.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 border-t border-l border-[#222]">
          {recognitions?.map((item, i) => (
            <a
              key={i}
              href={item?.link}
              className="block p-8 border-b border-r border-[#222] group hover:bg-[#181b1f] transition-colors duration-200"
            >
              <div className="flex flex-col gap-4 h-full">
                <div className="flex-1">
                  <h3 className="font-heading text-lg text-[#f5f5f8] font-medium mb-3 group-hover:text-[#80edfa] transition-colors duration-200">
                    {item?.title}
                  </h3>
                  <p className="text-sm text-[#666] leading-relaxed">{item?.description}</p>
                </div>
                <div className="flex items-center gap-2 text-[#aaa] group-hover:text-[#80edfa] transition-colors duration-200">
                  <span className="font-mono-brand text-[0.65rem] uppercase tracking-widest">
                    {item?.linkText}
                  </span>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6H10M7 3L10 6L7 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
